import { HttpBackend, HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import {Env} from "../../../environments/env";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root',
})
export class EnvService {
  private httpBackend = inject(HttpBackend);

  env: Env;
    private httpClient: HttpClient;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);
  constructor() {
    const httpBackend = this.httpBackend;

    this.httpClient = new HttpClient(httpBackend);
  }
  setConfig(): Observable<Env> {
    return this.httpClient
      .get<Env>('./assets/config/configuration.json')
      .pipe(map(config =>{
        this.env = config;
        return this.env;
      }));
  }

  readConfig(): Env {
    return this.env;
  }
}

